import constants from '../config/constants';
import { formDataRequest, postRequest } from '../libs/AxiosService.util';

export async function serviceGetVendors(params) {
    return await postRequest('vendor', params);
}
export async function serviceGetVendorDetail(params) {
    return await postRequest('vendor/detail', params);
}
export async function serviceVendorUpdate(params) {
    return await formDataRequest('vendor/update', params);
}
export async function serviceVendorCreate(params) {
    return await formDataRequest('vendor/create', params);
}
export async function serviceVendorIsExist(params) {
    return await postRequest('vendor/check', params);
}
export async function servicePrimaryUserAutoComplete(params) {
    return await postRequest('primary/user/autocomplete', params);
}
export async function serviceVendorExport (params,token) {  
    return await fetch(constants.DEFAULT_APP_URL+"feedbacks/export", {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token
    },
    body: JSON.stringify({
      ...params
    }),
  });
}
